// Matches anything on a print screen that is still loading. Gadgets show a
// CardSkeleton (data-testid="skeleton") while their data loads — not the
// Loading spinner — and a whole canvas shows CanvasLoading until its
// definitions resolve, so checking for spinners alone captures half-loaded
// reports. Mirrored in tools/report-renderer/src/renderReport.ts (a separate
// package); keep the two in sync.
const PRINT_LOADING_SELECTOR = [
  '[data-testid="loading"]',
  '[data-testid="skeleton"]',
  '[data-testid="canvas-loading"]',
].join(', ');

// Matches a gadget whose data request failed (GadgetLoadError). It isn't
// loading, so the print screen still signals ready, but the renderer retries
// the render rather than send it (until its final attempt). Mirrored in
// tools/report-renderer/src/renderReport.ts; keep the two in sync.
export const PRINT_ERROR_SELECTOR = '[data-testid="gadget-load-error"]';

export default PRINT_LOADING_SELECTOR;
